<ng-container *transloco="let t">
  <section class="content-subsidiaries-group">
    <div class="ui-title">{{ t('subsidiariesGroup.title') }}</div>

    <div class="group-wrapper">
      @if (subsidiariesByGroup().length) {
        <div class="group-content">
          <ul class="group-list">
            @for (subsidiaryGroup of subsidiariesByGroup(); track subsidiaryGroup.key) {
              <li>
                <button
                  class="group-item"
                  [disabled]="loading()"
                  (click)="autoSelectByGroup(subsidiaryGroup)"
                >
                  <pxw-icon icon="map-marker" size="sm" class="group-item__icon" />
                  <span class="group-item__name">{{ subsidiaryGroup.groupName }}</span>
                  <pxw-icon icon="chevron-right" size="xs" class="group-item__chevron" />
                </button>
              </li>
            }
          </ul>
        </div>
        @if (showGpsButton) {
          <div class="group-gps">
            <div class="ui-line-through ui-line-through--sm">
              <span class="ui-line-through__content">
                {{ t('subsidiariesGroup.gpsLabel') }}
              </span>
            </div>

            <pxw-button
              class="group-gps__button"
              color="blue"
              size="lg"
              display="block"
              [rounded]="true"
              [loading]="loadingGps()"
              (click)="selectByGps()"
            >
              <pxw-icon icon="geolocation" />
              @if (loadingGps()) {
                {{ t('subsidiariesGroup.searching') }}
              } @else {
                {{ t('subsidiariesGroup.detectLocation') }}
              }

              <pxw-icon icon="chevron-right" class="icon-right" />
            </pxw-button>

            <p class="group-gps__hint">{{ t('subsidiariesGroup.gpsHint') }}</p>
          </div>
        }
      }
    </div>
  </section>

  @if (loading()) {
    <div class="ui-loader ui-loader--with-overlay">
      <pxw-icon icon="loading" [spin]="true" />
    </div>
  }
</ng-container>
